/**
 * Calcul unifié TVA / HTVA depuis un montant TTC.
 * Formule standard : HTVA = TTC / (1 + taxRate / 100)
 */

export interface TaxBreakdown {
  htva: number;
  tva: number;
  ttc: number;
}

const round2 = (v: number): number => Math.round(v * 100) / 100;

export function calculateFromTTC(ttc: number, taxRate: number): TaxBreakdown {
  const htva = ttc / (1 + taxRate / 100);
  const tva = ttc - htva;
  return {
    htva: round2(htva),
    tva: round2(tva),
    ttc: round2(ttc),
  };
}
